

import { ComponentEvents } from 'global/interfaces/component.interface';
import ControllerBase from '../../../../global/js/ControllerBase';

type ComponentRefs = {
    categoryWrapper: 'categoryWrapper';
};

const EVENT_PREFIX = 'MoleculeToggleCategory__';


/** The type of custom events emitted in event.detail */
export type MoleculeToggleCategoryEventTypes = {
    UPDATE_FILTER_CATEGORY: {
        category: string
    };
    UPDATE_TOGGLED_CATEGORY: {
        category: string
    };
};

export const MoleculeToggleCategoryEvents: ComponentEvents<MoleculeToggleCategoryEventTypes> = {
    UPDATE_FILTER_CATEGORY: EVENT_PREFIX + 'UPDATE_FILTER_CATEGORY',
    UPDATE_TOGGLED_CATEGORY: EVENT_PREFIX + 'UPDATE_TOGGLED_CATEGORY',
};
export default class ControllerToggleSearchCategory extends ControllerBase<ComponentRefs> {
    categoryWrapper: HTMLElement;
    categoryMobileSelector: NodeListOf<HTMLInputElement>;
    categoryTriggers: NodeListOf<HTMLAnchorElement>;

    private static readonly componentRefs: ComponentRefs = {
        categoryWrapper: 'categoryWrapper',
    };

    constructor(element: HTMLElement) {
        super(element, [], Object.values(ControllerToggleSearchCategory.componentRefs));
        this.categoryWrapper = this.$references[ControllerToggleSearchCategory.componentRefs.categoryWrapper]
        this.categoryTriggers = this.categoryWrapper.querySelectorAll('a')
        this.categoryMobileSelector = this.$element.querySelectorAll('.m-filter-accordion input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
        this.observeCategoryTrigger()
        this.registerEvents()
    }

    private handleCategoryActiveState(currentCategory: string): void {
        this.categoryTriggers.forEach(element => {
            const elementCategory = element.dataset.category
            if (currentCategory === elementCategory) {
                if (!element.classList.contains('uk-active')) element.classList.add('uk-active')
            } else {
                element.classList.remove('uk-active')
            }
        })
    }

    private observeCategoryTrigger(): void {
        this.categoryTriggers.forEach(element => element.addEventListener('click', (e: Event) => {
            e.preventDefault()
            const trigger = e.currentTarget as HTMLElement
            if (trigger) {
                const category = trigger.dataset.category
                if (category) {
                    this.dispatchCustomEvent(MoleculeToggleCategoryEvents.UPDATE_FILTER_CATEGORY, { category }, false, true)
                    this.handleCategoryActiveState(category)
                }
            }
        }));
        for(const check of this.categoryMobileSelector) {
            const checkbox = check as HTMLInputElement;
            checkbox.addEventListener('click',e=>{
                const category = checkbox.value;
                this.dispatchCustomEvent(MoleculeToggleCategoryEvents.UPDATE_FILTER_CATEGORY, { category }, false, true)
                this.handleCategoryActiveState(category)
            });
        }
    }

    private registerEvents() {
        window.addEventListener(MoleculeToggleCategoryEvents.UPDATE_TOGGLED_CATEGORY, (event: CustomEvent) => this.handleCategoryActiveState(event.detail.category))
    }

}